import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography, withWidth, withStyles } from "@material-ui/core";

const styles = theme => ({
  wrapper: {
    color: theme.palette.common.white,
    paddingLeft: 30,
    paddingRight: 30,
    [theme.breakpoints.down('sm')]:{
      paddingLeft: 0,
      paddingRight: 0,
    }
  },
  column: {
    paddingLeft: 30,
    paddingRight: 30,
    [theme.breakpoints.down('sm')]:{
      paddingLeft: 10,
      paddingRight: 10,
    }
  },
});

function MainSection({ classes }) {

  const renderContactLink = () => {
    return (
      <a href='mailto: info@nexspec.com' style={{color: 'white', '&hover': 'pointer'}}>
        contact us
      </a>
    )
  }

  return (    
    <Grid container className={classes.wrapper}>
      <Grid item sm={12} md={12} className={classes.column}>
        <Typography variant="h3" style={{marginBottom: 30}}>Let's Work Together.</Typography>
        <Typography variant="body1" style={{marginBottom: 40, paddingBottom: 120}}>
          Please {renderContactLink()} and provide some information on your project or goals, and we'll move the conversation on from there.
        </Typography>
      </Grid>
    </Grid>
  );
}

MainSection.propTypes = {
  width: PropTypes.string.isRequired,
};

export default withStyles(styles, { withTheme: true })(withWidth()(MainSection));
